import { Station } from '../types/stationTypes'
import { getToken } from './tokenService'
import { useErrorStore } from '../stores/errorStore'
import { getDefaultHeaders } from '../utils/languageUtils'

const BASE_URL = import.meta.env.VITE_API_BASE_URL

export const fetchStations = async (): Promise<Station[]> => {
  const errorStore = useErrorStore()
  const token = await getToken()
  const headers = await getDefaultHeaders(token)

  try {
    const response = await fetch(`${BASE_URL}/api/v2/meta/stations`, {
      method: 'GET',
      headers,
    })

    if (!response.ok) {
      const error = 'Kunne ikke hente stasjoner.'
      errorStore.setError(error)
      throw new Error(error)
    }

    return (await response.json()) as Station[]
  } catch (error) {
    console.error('Error fetching stations:', error)
    throw error
  }
}

export const fetchDestinationSuggestions = async (uicStationCode: string): Promise<string[]> => {
  const errorStore = useErrorStore()
  const token = await getToken()
  const headers = await getDefaultHeaders(token)

  try {
    const response = await fetch(`${BASE_URL}/api/v2/meta/stations/${uicStationCode}`, {
      method: 'GET',
      headers,
    })

    if (!response.ok) {
      const error = 'Kunne ikke hente destinasjonsforslag.'
      errorStore.setError(error)
      throw new Error(error)
    }

    const data = await response.json()
    return (data.connected_stations || []) as string[]
  } catch (error) {
    console.error('Error fetching destination suggestions:', error)
    throw error
  }
}
